import {
  LayoutDashboard,
  Users,
  Camera,
  ShieldCheck,
  CalendarDays,
  UserCircle,
  FileText,
  Heart,
  BookOpen,
  CreditCard,
  FileSignature,
  MessageSquare,
  Image,
  Star,
  AlertTriangle,
  FileEdit,
  BarChart3,
  ImagePlus,
  Settings as SettingsIcon,
} from "lucide-react";

// `built: true` modules render real, database-backed functionality.
// `built: false` modules render the "Module Not Yet Built" placeholder — the route
// exists (per spec) but no functionality has been implemented for it yet.
export const NAV_ITEMS = [
  { key: "dashboard", label: "Dashboard", to: "/admin", icon: LayoutDashboard, built: true },
  { key: "users", label: "Users", to: "/admin/users", icon: Users, built: true },
  { key: "photographers", label: "Photographers", to: "/admin/photographers", icon: Camera, built: true },
  { key: "verification", label: "Verification", to: "/admin/verification", icon: ShieldCheck, built: true },
  { key: "photo-review", label: "Photo Review", to: "/admin/photo-review", icon: ImagePlus, built: true },
  { key: "sessions", label: "Sessions", to: "/admin/sessions", icon: CalendarDays, built: true },
  { key: "strangers", label: "Strangers", to: "/admin/strangers", icon: UserCircle, built: true },
  { key: "applications", label: "Applications", to: "/admin/applications", icon: FileText, built: true },
  { key: "matches", label: "Matches", to: "/admin/matches", icon: Heart, built: true },
  { key: "bookings", label: "Bookings", to: "/admin/bookings", icon: BookOpen, built: true },
  { key: "payments", label: "Payments", to: "/admin/payments", icon: CreditCard, built: true },
  { key: "waivers", label: "Waivers", to: "/admin/waivers", icon: FileSignature, built: false },
  { key: "messages", label: "Messages", to: "/admin/messages", icon: MessageSquare, built: true },
  { key: "galleries", label: "Galleries", to: "/admin/galleries", icon: Image, built: true },
  { key: "reviews", label: "Reviews", to: "/admin/reviews", icon: Star, built: true },
  { key: "safety", label: "Safety", to: "/admin/safety", icon: AlertTriangle, built: true },
  { key: "content", label: "Content", to: "/admin/content", icon: FileEdit, built: true },
  { key: "analytics", label: "Analytics", to: "/admin/analytics", icon: BarChart3, built: true },
  { key: "settings", label: "Settings", to: "/admin/settings", icon: SettingsIcon, built: true },
];
